import html2pdf from "html2pdf.js";
import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import numberToWords from "number-to-words";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import www from '../Examination/GradeCard/www.png'

const PrintSpecialFeeRecipt = (props) => {
   // this code is the html for the pdf
  const { logoData, loading, error } = useSelector((state) => state.schoolLogo);
  const {
    name,
    code,
    receiptNo,
    receiptDate,
    selectFeeType,
    paymentInfo,
    schoolUser,
    session,
    classSec,
    saveSpecialFees,
    btnClick,
    convertDate,
    navigate,
    handleClear,
    alert, receiptType,
  } = props;
  const { email, user_detail } = schoolUser;
  const {
    school_name,
    organization_name,
    school_address,
    school_contact_email,
    school_contact_number,
    school_pincode,
    udise_no,
    school_logo,
  } = user_detail;
  const {
    payment_mode,
    total_amount,
    fine_amount,
    paid_amount,
    bank_name,
    pay_no,
    pay_date,
    remark,
  } = paymentInfo;
  const [searchResults, setSearchResults] = useState([]);
  const [noResultsMessage, setNoResultsMessage] = useState("");
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const toggle = () => {
    setModal(!modal);
    setSearchResults([]);
    setNoResultsMessage("");
  };
  const toggle1 = () => {
    setModal1(!modal1);
  };

  const handleConvertToPdf = async () => {
    const element = document.getElementById("divToConvert");
    if (element) {
      const opt = {
        margin: 10,
        filename: "generated.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      // Generate the PDF content as a data URL
      const pdfDataUri = await html2pdf()
        .from(element)
        .set(opt)
        .outputPdf("datauristring");

      // Open the PDF in a new tab
      const newTab = window.open();
      newTab.document.write(
        '<style> body { margin: 0px !important; overflow: hidden !important; }</style><iframe width="100%" height="100%" src="' +
          pdfDataUri +
          '"></iframe>'
      );
      newTab.document.close();
      // saveSpecialFees();
      handleClear();
      toggle1();
    }
  };

  const words = numberToWords.toWords(Number(paid_amount));
  const  handelClose = () => {
    handleClear()
    toggle1()
  }

  return (
    <>
      <button
        disabled={name ? false : true}
        type="button"
        className="btn btn-sm btn-primary btn-block p-2 my-2 page-breadcrumb "
        onClick={() => {
          if (!code) {
            alert.error("Please enter Student Code");
          } else if (!selectFeeType) {
            alert.error("Please select Special Fees");
          } else if (!paymentInfo.total_amount) {
            alert.error("Please enter Total Amount");
          } else {
            Swal.fire({
              title: "CONFIRMATION",
              text: "You want to Save Fee Receipt?",
              icon: "question",
              showDenyButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Save",
              denyButtonText: `No`,
              allowOutsideClick: false,
            }).then(async (result) => {
              if (result.isConfirmed) {
                await saveSpecialFees();
                Swal.fire({
                  title: "CONFIRMATION",
                  text: receiptType === "New" ? "Special Fees receipt saved succesfully. Do you want to Proceed for fee Receipt?" : "Special Fees receipt Update succesfully. Do you want to Proceed for fee Receipt?",
                  icon: "success",
                  showDenyButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#f46a6a",
                  confirmButtonText: "Yes",
                  denyButtonText: `No`,
                  allowOutsideClick: false,
                  // willClose: (e) => {
                  //   handleClear();
                  // },
                }).then((result) => {
                  if (result.isConfirmed) {
                    toggle1();
                
                  } else if (result.isDenied) {
                    handleClear();
                  }
                });
              } else if (result.isDenied) {
                handleClear();
              }
            });
          }
        }}
      >
      {receiptType === "New"
          ? "Save And Print Receipt"
          : "Update And Print Receipt"}
      </button>
      <Modal isOpen={modal1} toggle={toggle1} fullscreen className="modal-lg" backdrop="static">
        <ModalBody>
          <div className="container-fluid" id="divToConvert">
            <main>
            <div className="d-flex align-items-stretch">
               
               <div className="col-3 m-auto">
                 {logoData ? (
                   <img
                     src={`data:image/png;base64,${logoData}`}
                     alt="school_logo"
                     width={100}
                     height={100}
                     className=""
                     style={{ borderRadius: "50%" }}
                   />
                 ) : (
                  <img
                  src={www} 
                  alt="fallback_image"
                  width={100}
                  height={100}
                  style={{ borderRadius: "50%" }}
                />
                 )}
              </div>

          
               <div className="col-9">
                 <div className="text-center col-8">
                   <p className="font-weight-bold text-dark">{organization_name}</p>
                   <div className="font-weight-bold">
                     {school_name}
                   </div>
                   <div>
                     <h6>{school_address}</h6>
                     <h6 style={{fontSize: "0.7rem"}}>
                       Pincode- {school_pincode}, Ph: {school_contact_number}
                     </h6>
                     <h6 style={{fontSize: "0.7rem"}}>E-mail: {school_contact_email}</h6>
                   </div>
                 </div>
               </div>
             </div> 
              <hr className="border border-dark" />

              <section>
                <div className="row">
                  <div className="col-6">
                    {/* <h6>Reg No : {udise_no}</h6> */}
                    <h6>Name : {name}</h6>
                    <h6>Class : {classSec}</h6>
                  </div>
                  <div className="col-6">
                    {/* <h6>Session : {session}</h6> */}
                    <h6>Receipt No : {receiptNo}</h6>
                    <h6>Receipt Date : {convertDate(receiptDate)}</h6>
                  </div>
                </div>

                <div className="row clearfix">
                  <div className="table-responsive card">
                    <table className="table table-hover table-vcenter  mb-0 text-nowrap ">
                      <thead className="ehed text-center ">
                        <th className="font-weight-bold text-dark">Sr. No</th>
                        <th className="font-weight-bold text-dark">Particular(s) </th>
                        <th className="font-weight-bold text-dark">Amount</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1.</td>
                          <td className="">{selectFeeType}</td>
                          <td className="text-right font-weight-bold">{total_amount}</td>
                        </tr>
                        <tr>
                          <th colSpan={2} className="text-right Total text-dark font-weight-bold">
                            Total Amount
                          </th>
                          <td className="Total font-weight-bold text-right">{total_amount}</td>
                        </tr>
                        {/* <tr>
                          <th colSpan={2} className="text-right">
                            Balance Amount
                          </th>
                          <td className="">{0}</td>
                        </tr> */}
                        <tr>
                          <th colSpan={2} className="text-right text-dark font-weight-bold">
                            Fine Amount
                          </th>
                          <td className="   font-weight-bold text-right">{fine_amount}</td>
                        </tr>
                        <tr>
                          <th colSpan={2} className="text-right Total text-dark font-weight-bold">
                            Paid Amount
                          </th>
                          <td className=" Total font-weight-bold text-right">
                            <strong>{paid_amount}</strong>
                          </td>
                        </tr>

                        <tr>
                          <th colSpan={1} className="font-weight-bold text-dark ">In Word</th>
                          <th colSpan={1} className="text-right font-weight-bold">
                            <strong className="font-weight-bold text-dark">{words} Rupees</strong>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h6>Payment Mode : {payment_mode}</h6>
                  {payment_mode === "Cash" ? null : (
                    <>
                      {payment_mode === "UPI" ? null : (
                        <h6>Bank Name : {bank_name}</h6>
                      )}
                      <h6>
                        {payment_mode === "Bank" ? "Account" : payment_mode} No.
                        : {pay_no}
                      </h6>
                      <h6>Payment Date : {convertDate(pay_date)}</h6>
                    </>
                  )}
                </div>
              </section>
              <hr className="border border-dark" />

              <footer className="row pt-5 mt-5">
                <div className="col-6">
                  <h6>Received By : Clerk </h6>
                </div>
                <div className="col-6 text-right">
                  <h6>Signature </h6>
                </div>
                <hr />
              </footer>
            </main>
          </div>
          <div className="text-center mt-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                handleConvertToPdf();
              }}
            >
              Print Fees Receipt
            </button>
             <button className="btn btn-secondary ml-2" onClick={handelClose} >
              Close
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PrintSpecialFeeRecipt;
